export default __webpack_public_path__ + "static/media/vitra_chair_05.ae5472ad.png";